module.exports = __webpack_public_path__ + "img/2.6c2d7974.jpg";